import Vue from 'vue'
import Vuex from 'vuex'
import role from '@/store/role/role.js'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    role
  }
})
